var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentMarketing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theme-transition",
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "theme-tranistion",
    clipPath: "url(#clip0_1_11)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.098 170.307C152.146 170.267 174.04 148.227 174 121.081C173.96 93.934 152.001 71.9598 124.952 72.0001C97.9043 72.0403 76.01 94.0797 76.0501 121.226C76.0624 129.611 78.1658 137.502 81.8641 144.404L81.8623 144.411L76.1254 167.072C75.3687 170.061 78.164 172.728 81.1002 171.819L102.787 165.105C102.846 165.087 102.903 165.068 102.96 165.048C109.612 168.423 117.134 170.319 125.098 170.307ZM151.004 104.789H98.9961V110.682H151.004V104.789ZM98.9961 118.259H151.004V124.153H98.9961V118.259ZM151.004 131.309H98.9961V137.623H151.004V131.309Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 124,
    stroke: "#757572",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentMarketing);
export default __webpack_public_path__ + "static/media/ContentMarketing.f7f412c9eed7f65cfe96f62677ff4d73.svg";
export { ForwardRef as ReactComponent };